module.exports = __webpack_public_path__ + "static/img/samcheok-international-conference.fe7032a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/samcheok-international-conference.jpg
// module id = 2d3Q
// module chunks = 0